import type { CrawlJobStatusDTO } from '../../types/knowledge';

/** Prefer `next` fields; keep prior histogram arrays when the update omits them. */
export function mergeCrawlJobStatusDto(
  previous: CrawlJobStatusDTO | undefined,
  next: CrawlJobStatusDTO,
): CrawlJobStatusDTO {
  if (!previous) {
    return next;
  }

  return {
    ...previous,
    ...next,
    pageStatusCounts: next.pageStatusCounts ?? previous.pageStatusCounts,
    stagingDocumentStatusCounts:
      next.stagingDocumentStatusCounts ?? previous.stagingDocumentStatusCounts,
    publishedDocumentStatusCounts:
      next.publishedDocumentStatusCounts ??
      previous.publishedDocumentStatusCounts,
    mappedUrlCount: next.mappedUrlCount ?? previous.mappedUrlCount,
    mappingDuration: next.mappingDuration ?? previous.mappingDuration,
    crawlingDuration: next.crawlingDuration ?? previous.crawlingDuration,
    embeddingDuration: next.embeddingDuration ?? previous.embeddingDuration,
  };
}

export function crawlStatusHasHistogramCounts(
  status: CrawlJobStatusDTO | null | undefined,
): boolean {
  return (
    status?.pageStatusCounts != null ||
    status?.stagingDocumentStatusCounts != null ||
    status?.publishedDocumentStatusCounts != null
  );
}
